var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{staticClass:"page-live-chat",attrs:{"page-content":false},on:{"page:afterin":_vm.pageAfterIn,"page:afterout":_vm.pageAfterOut}},[_c('f7-navbar',{attrs:{"title":"LiveChat","backLink":"Trở lại"}}),_c('f7-page-content',[_c('iframe',{attrs:{"src":"https://jivo.chat/m4NYwIHnBX","frameborder":"0","width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }